import { render, staticRenderFns } from "./VitalCheck.vue?vue&type=template&id=9cc8f480&scoped=true&"
import script from "./VitalCheck.vue?vue&type=script&lang=js&"
export * from "./VitalCheck.vue?vue&type=script&lang=js&"
import style0 from "./VitalCheck.vue?vue&type=style&index=0&id=9cc8f480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc8f480",
  null
  
)

export default component.exports